import React, { Component, Fragment } from "react";
import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import Table from "./../../../general/Table/Table";
import { withRouter } from "react-router-dom";

//import classes from "./RemovalTable.module.scss";
import EditIcon from '@mui/icons-material/Edit';
import Moment from "moment";
import DataTable from "../../../general/DataTable/DataTable";
import { boxiPrimary } from "../../../../assets/style/colors";

axios.defaults.withCredentials = true;

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

class RemovalTable extends Component {

  state = {
    upcoming_removals_data: [],
    completed_removals_data: [],
    isLoading: false,



    upcomingRemovalsColumns: [
      { width: 20, field: 'id', headerName: '#', sortable: false },
      { flex: 3, field: 'vendor_name', headerName: 'Vendor Name' },
      { flex: 1, field: 'vendor_city', headerName: 'Vendor City' },
      { flex: 1, field: 'truck_name', headerName: 'Truck Name' },
      { flex: 1, field: 'license_plate', headerName: 'License Plate' },
      { flex: 1, field: 'campaign_name', headerName: 'Campaign Name' },
      { flex: 1, field: 'payment_schedule_end_date', headerName: 'Payment End Date' },
      { flex: 1, field: 'days_left', headerName: 'Days Left' },
      { width: 30, field: 'btn', headerName: '', sortable: false, renderCell: (params) => {
        return (
          <EditIcon onClick={() => {
            let data = {
              id: params.row.removal_id,
              vendor_name: params.row.vendor_name,
              truck_id: params.row.truck_id
            };
    
            this.props.toggleHandler({data, title: 'Edit Upcoming Removal'});
          }} style={{ color: boxiPrimary, cursor: 'pointer' }}>
          </EditIcon>
        );
      } }
    ],
    upcomingRemovalsRows: [],
    upcomingRemovalsParams: {
      sortOrder: 'asc',
      sortBy: 'vendor_name',
      page: 0,
      pageSize: 10,
      search: null
    },
    isUpcomingRemovalsLoading: false,
    totalUpcomingRemovals: 0,


    completedRemovalsColumns: [
      { width: 20, field: 'id', headerName: '#', sortable: false },
      { flex: 3, field: 'vendor_name', headerName: 'Vendor Name' },
      { flex: 1, field: 'vendor_city', headerName: 'Vendor City' },
      { flex: 1, field: 'truck_name', headerName: 'Truck Name' },
      { flex: 1, field: 'license_plate', headerName: 'License Plate' },
      { flex: 1, field: 'campaign_name', headerName: 'Campaign Name' },
      { flex: 1, field: 'payment_schedule_end_date', headerName: 'Payment End Date' },
      { flex: 1, field: 'days_left', headerName: 'Days Left' },
      { width: 30, field: 'btn', headerName: '', sortable: false, renderCell: (params) => {
        return (
          <EditIcon onClick={() => {
            let data = {
              id: params.row.removal_id,
              vendor_name: params.row.vendor_name,
              truck_id: params.row.truck_id
            };
    
            this.props.toggleHandler({data, title: 'Edit Completed Removal'});
          }} style={{ color: boxiPrimary, cursor: 'pointer' }}>
          </EditIcon>
        );
      } }
    ],
    completedRemovalsRows: [],
    completedRemovalsParams: {
      sortOrder: 'asc',
      sortBy: 'vendor_name',
      page: 0,
      pageSize: 10,
      search: null
    },
    isCompletedRemovalsLoading: false,
    totalCompletedRemovals: 0
  }

  constructor(props){
    super(props);
    console.log(props);
    // this.getUpcomingRemovals();
  }

  getUpcomingRemovals = (sortOrder = 'asc', sortBy = 'vendor_name', page = 0, pageSize = 10, search = null) => {

    const params = {
      sortOrder, 
      sortBy, 
      page, 
      pageSize,
      search
    }

    this.setState({
      upcomingRemovalsParams: params,
      isUpcomingRemovalsLoading: true
    })
    axios.get(`${process.env.REACT_APP_API_HOST}/get-upcoming-removals`, { params }, {withCredentials: true})
    .then((response) => {
      const upcomingRemovals = [];
      response.data.upcoming_removals.map((upcoming_removal, index) => {
          upcomingRemovals.push({
            id: (page * pageSize) + index + 1,
            removal_id: upcoming_removal.removal_id,
            payment_schedule_id: upcoming_removal.payment_schedule_id,
            truck_id: upcoming_removal.truck_id,
            payment_schedule_end_date: Moment.utc(upcoming_removal.payment_schedule_end_date).format("MM/DD/YYYY"),
            truck_name: upcoming_removal.truck_name,
            license_plate: upcoming_removal.license_plate,
            vendor_name: upcoming_removal.vendor_name,
            vendor_city: upcoming_removal.vendor_city,
            campaign_name: upcoming_removal.campaign_name,
            days_left: Moment.utc(upcoming_removal.payment_schedule_end_date).diff(Moment.utc(), 'days')
          })
        });
      this.setState({
        upcomingRemovalsRows: upcomingRemovals,
        isUpcomingRemovalsLoading: false,
        totalUpcomingRemovals: response.data.rowCount
      });
      // this.props.setLoading(false)
    })
    .catch((err) => {
      this.setState({
        isUpcomingRemovalsLoading: false
      });
      // this.props.setLoading(false)
      console.log(err);
    })
  };

  getCompletedRemovals = (sortOrder = 'asc', sortBy = 'vendor_name', page = 0, pageSize = 10, search = null) => {

    const params = {
      sortOrder, 
      sortBy, 
      page, 
      pageSize,
      search
    }

    this.setState({
      completedRemovalsParams: params,
      isCompletedRemovalsLoading: true
    })

    axios.get(`${process.env.REACT_APP_API_HOST}/get-completed-removals`, { params }, {withCredentials: true})
    .then((response) => {
      const completedRemovals = [];
      response.data.completed_removals.map((completed_removal, index) => {
          completedRemovals.push({
            id: (page * pageSize) + index + 1,
            removal_id: completed_removal.removal_id,
            payment_schedule_id: completed_removal.payment_schedule_id,
            truck_id: completed_removal.truck_id,
            payment_schedule_end_date: Moment.utc(completed_removal.payment_schedule_end_date).format("MM/DD/YYYY"),
            truck_name: completed_removal.truck_name,
            license_plate: completed_removal.license_plate,
            vendor_name: completed_removal.vendor_name,
            vendor_city: completed_removal.vendor_city,
            campaign_name: completed_removal.campaign_name,
            days_left: Moment.utc(completed_removal.payment_schedule_end_date).diff(Moment.utc(), 'days')
          })
        });
      this.setState({
        completedRemovalsRows: completedRemovals,
        isCompletedRemovalsLoading: false,
        totalCompletedRemovals: response.data.rowCount
      });
      // this.props.setLoading(false)
    })
    .catch((err) => {
      this.setState({
        isUpcomingRemovalsLoading: false
      });
      // this.props.setLoading(false)
      console.log(err);
    })
  };

  upcomingRemovalButtons = [
    {
      display: "View",
      onClickHandler: (index, id) => {
        let selectedRemoval = this.state.upcoming_removals_data.find((removal) => removal[0] === id);
        console.log(selectedRemoval);
        let data = {
          id: selectedRemoval[0],
          vendor_name: selectedRemoval[2],
          truck_id: selectedRemoval[4],
          //truck_id: problem[3],
        };
        //console.log("id: " + id + " data: " + JSON.stringify(data));
        this.props.toggleHandler({data, title: 'Edit Upcoming Removal'});
      }
    }
  ];
  completedRemovalButtons = [
    {
      display: "View",
      onClickHandler: (index, id) => {
        let selectedRemoval = this.state.completed_removals_data.find((removal) => removal[0] === id);
        console.log(selectedRemoval);
        let data = {
          id: selectedRemoval[0],
          vendor_name: selectedRemoval[2],
          truck_id: selectedRemoval[4],
        };

        this.props.toggleHandler({data, title: 'Edit Completed Removal'});
      }
    }
  ];

  upcomingRemovalsTableHeaders = [
    "id",
    "Vendor Name",
    "Vendor City",
    "Truck Name",
    "License Plate",
    "Campaign Name",
    "Payment End Date",
    "Days Left",
  ];
  completedRemovalsTableHeaders = [
    "id",
    "Vendor Name",
    "Vendor City",
    "Truck Name",
    "License Plate",
    "Campaign Name",
    "Payment End Date",
    "Removal Date",
  ];
  componentWillReceiveProps (nextProps){
    if (nextProps.needsRefresh == true){
      console.log('componentWillReceiveProps');
      this.getUpcomingRemovals();
    }
  }

  componentDidMount()
  {
    this.getUpcomingRemovals();
    this.getCompletedRemovals();
  }

  render() {
    const sectionStyle = {
      boxShadow: "none",
      marginBottom: "20px"
    };
    const buttonStyle = {
      float: "right",
      marginLeft: "20px",
      width: "100px"
    };
    return (
      <Fragment>

      {/* <Table
      title="Upcoming Removals"
      id="upcoming-removals-table"
      data={this.state.upcoming_removals_data}
      headers={this.upcomingRemovalsTableHeaders}
      buttons={this.upcomingRemovalButtons}
      sectionStyle={sectionStyle}
      isLoading={this.state.isLoading}
      loadingText="Loading Upcoming Removals..."
      colors={["#dbbb04", "#d47800"]} /> */}
      <DataTable
        title="Upcoming Removals"
        rows={this.state.upcomingRemovalsRows}
        columns={this.state.upcomingRemovalsColumns}
        fetchData={this.getUpcomingRemovals}
        params={this.state.upcomingRemovalsParams}
        isLoading={this.state.isUpcomingRemovalsLoading}
        rowCount={this.state.totalUpcomingRemovals}
      />

      <br />
      <br />
      {/* <Table
      title="Completed Removals"
      id="completed-removals-table"
      data={this.state.completed_removals_data}
      headers={this.completedRemovalsTableHeaders}
      buttons={this.completedRemovalButtons}
      sectionStyle={sectionStyle}
      isLoading={this.state.isLoading}
      loadingText="Loading Completed Removals..."
      colors={["#BCBEC2", "#E1E4E8"]} /> */}

      <DataTable
        title="Completed Removals"
        rows={this.state.completedRemovalsRows}
        columns={this.state.completedRemovalsColumns}
        fetchData={this.getCompletedRemovals}
        params={this.state.completedRemovalsParams}
        isLoading={this.state.isCompletedRemovalsLoading}
        rowCount={this.state.totalCompletedRemovals}
      />
      </Fragment>
    );
  }
}
export default withRouter(RemovalTable);
